import React, {useEffect} from 'react';

import {Spinner} from 'components/spinner';
import {useAppDispatch, useAppSelector} from 'store/config/hooks';
import {selectThunkStatus} from 'store/slices/loading-state-slice';
import {selectRequestData} from 'store/slices/request-slice/request-selectors';
import {requestSliceActions} from 'store/slices/request-slice/request-slice';
import {loadRequestData, readRequest} from 'store/slices/request-slice/request-slice-thunks';

import {RequestForm} from './request-form/request-form';

interface IRequestProps {
    id: string;
    entityName: string;
    url: string;
    onClose: () => void;
}

export const Request = ({
    id, entityName, onClose, url,
}: IRequestProps) => {
    const dispatch = useAppDispatch();
    const requestsData = useAppSelector(selectRequestData);
    const {resetRequestData} = requestSliceActions;
    const {
        isPending: isLoadingRequestData,
    } = useAppSelector(s => selectThunkStatus(s, loadRequestData.typePrefix));

    useEffect(() => {
        if (!requestsData) {
            dispatch(loadRequestData({id, url}));
        }
    }, [url, requestsData]);

    useEffect(() => {
        dispatch(readRequest({ids: [id]}));

        return () => {
            dispatch(resetRequestData());
        };
    }, []);

    return (
        <>
            {isLoadingRequestData ? <Spinner />
                : (requestsData && (
                    <RequestForm
                        entityName={entityName}
                        onClose={onClose}
                        requestsData={requestsData}
                    />
                ))}
        </>
    );
};
